import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { GridRow, GridCol } from '@lmig/lmds-react';
import Logger from '@lmig/dotcom-utilities-helpers/logger';

const logger = new Logger('client:UnimplementedCatch');

const {
  publicRuntimeConfig: { layoutDebugging = false },
} = getConfig() || { publicRuntimeConfig: {} };

const UnimplementedCatch = ({ component = '', componentProps = {} }) => {
  const { asPath, pathname } = useRouter();
  const isDebugging = layoutDebugging === 'true';

  logger.error(`Bad component definition "${component}" in layout: ${pathname} at url: ${asPath}`);

  if (!isDebugging) {
    return null;
  }

  let props;

  try {
    props = JSON.stringify(componentProps, null, 1);
  } catch (e) {
    props = 'JSX';
  }

  return (
    <GridRow mainGrid>
      <GridCol base={12}>
        <div>
          <pre>Component Name: {component}</pre>
          <pre>Props: {props}</pre>
        </div>
      </GridCol>
      <style jsx>{`
        div {
          border: solid 1px red;
          padding: 1rem;
          background-color: rgba(255, 255, 255, 0.2);
        }
      `}</style>
    </GridRow>
  );
};

UnimplementedCatch.propTypes = {
  component: PropTypes.string,
  componentProps: PropTypes.shape(),
};

export default UnimplementedCatch;
